import React, { useState, useMemo } from 'react'
import { Button, Modal, Col, Row, Input, Select, message, Tooltip } from 'antd'
import * as lodash from 'lodash'
import { updateMaterial } from '../../../services/api/apiSku'

const MaterialNewModal = ({ item, loading, setLoading, onReload }) => {
    const [isOpen, setIsOpen] = useState(false)
    const [name, setName] = useState('')
    const [codeName, setCodeName] = useState('')
    const [code, setCode] = useState('')
    const [partner, setPartner] = useState('')

    const isDisabled = useMemo(() => !!name.trim() , [name])

    const onShowModal = () => {
        setIsOpen(true)
        setName(item.name)
        setCodeName(item.description)
        setCode(item.code)
        setPartner(lodash.get(item, 'partner.name'))
    }

    const onCancel = () => {
        setIsOpen(false)
        setName('')
        setCodeName('')
        setCode('')
        setPartner('')
    }

    const hanldeChange = (field, value) => {
        if (field === "name") setName(value)
        if (field === "codeName") setCodeName(value)
        if (field === "code") setCode(value)
        if (field === "partner") setPartner(value)
    }

    const onUpdateMaterial = async () => {
        setLoading(true)
        try {
            const payload = {
                name
            }

            const { data} = await updateMaterial(payload, item._id)
            const {success, message: mess} = data
            if (!success) return message.error(mess)

            message.success("Chỉnh sửa nguyên vật liệu thành công")
            onCancel()
            onReload()
        } catch (error) {
            message.error(error.message)
        } finally {
            setLoading(false)
        }
    }

    return (
        <>
            <Tooltip title='Chỉnh sửa'>
                <i className="icon-pencil" onClick={onShowModal} />
            </Tooltip>
            <Modal
                width="500px"
                className="NewModalMaterial"
                visible={isOpen}
                title="Chỉnh sửa nguyên vật liệu"
                onOk={onUpdateMaterial}
                onCancel={onCancel}
                footer={[
                    <Button key="back" onClick={onCancel}>
                        Hủy
                    </Button>,
                    <Button type="primary" loading={loading} onClick={onUpdateMaterial} disabled={!isDisabled}>
                        Cập nhật
                    </Button>,
                ]}
            >
                <Row className='mb-3 justify-content-between'>
                    <Col span={4}>
                        <span className='font-weight-bold'>Tên</span>
                    </Col>
                    <Col span={18}>
                        <Input
                            placeholder='Nhập tên'
                            value={name}
                            onChange={e => hanldeChange('name', e.target.value)}
                        />
                    </Col>
                </Row>

                <Row className='mb-3 justify-content-between'>
                    <Col span={4}>
                        <span className='font-weight-bold'>Mã nguyên vật liệu</span>
                    </Col>
                    <Col span={18}>
                        <Input
                            placeholder='Nhập mã NVL'
                            value={codeName}
                            disabled
                        />
                    </Col>
                </Row>

                <Row className='mb-3 justify-content-between'>
                    <Col span={4}>
                        <span className='font-weight-bold'>Mã hóa</span>
                    </Col>
                    <Col span={18}>
                        <Input
                            placeholder='Nhập mã'
                            value={code}
                            disabled
                        />
                    </Col>
                </Row>

                <Row className='justify-content-between'>
                    <Col span={4}>
                        <span className='font-weight-bold'>Partner sản xuất</span>
                    </Col>
                    <Col span={18}>
                        <Select
                            placeholder='Nhập partner sản xuất'
                            style={{ width: '100%' }}
                            value={partner || []}
                            disabled
                        />
                    </Col>
                </Row>
            </Modal>
        </>
    )
}

export default MaterialNewModal